const STORAGE_KEY = 'payhook:accountId'
const ACCOUNT_LABEL_KEY = 'payhook:accountLabel'

export function getStoredAccountId () {
  return window.localStorage.getItem(STORAGE_KEY)
}

export function setStoredAccountId (accountId) {
  window.localStorage.setItem(STORAGE_KEY, accountId)
}

export function clearStoredAccountId () {
  window.localStorage.removeItem(STORAGE_KEY)
  window.localStorage.removeItem(ACCOUNT_LABEL_KEY)
}

export function setStoredAccountLabel (label) {
  if (label) {
    window.localStorage.setItem(ACCOUNT_LABEL_KEY, label)
  }
}

function setConnectVisible (visible) {
  document.querySelectorAll('[data-connect-cta]').forEach((el) => {
    el.hidden = !visible
  })
}

export function updateSiteHeader () {
  const accountId = getStoredAccountId()
  const isConnected = Boolean(accountId)

  setConnectVisible(!isConnected)
}

function closeMobileMenu () {
  const header = document.querySelector('.site-header')
  const toggle = document.getElementById('header-menu-toggle')
  if (!header || !toggle) return

  header.classList.remove('is-open')
  toggle.setAttribute('aria-expanded', 'false')
  toggle.setAttribute('aria-label', 'Open menu')
}

function initMobileMenu () {
  const toggle = document.getElementById('header-menu-toggle')
  const header = document.querySelector('.site-header')
  const panel = document.getElementById('site-header-nav')
  if (!toggle || !header || !panel) return

  toggle.addEventListener('click', () => {
    const open = header.classList.toggle('is-open')
    toggle.setAttribute('aria-expanded', String(open))
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu')
  })

  panel.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMobileMenu)
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMobileMenu()
  })

  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) closeMobileMenu()
  })
}

export function initSiteHeader () {
  updateSiteHeader()
  initMobileMenu()
}
